<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <span>{{data.item.datosBandeja[data.field.key]  | formatoFechaHoraTexto }}</span>
  </div>

</template>

<script>

    export default {
        name: "BandejaFechaTextoCobroPtiComponente",
        props: {
            data: Object
        },
      data: () => ({
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
      }),
      created(){
        this.debug = this.$localStorageService.getDebug();
      },
    }

</script>
